export class ShashwathaSeva{
    phone:any;
    name:string;
    gotra:string;
    nakshatra:string;
    address:string;
    emailid:string;
    is_life_member:any;
    is_special_member:any;
    seva_id:number;
    repetition_type:number;
    start_date:any;
    end_date:any;
    booked_by:any;
    amount:number;
    paymenttype:any;
    paymentnote:string;
    is_active:any;
    weekday:number;
    maasa:any;
    paksha:any;
    tithi:any;
    seva_nakshatra:any;
    updated_by:any;
    special_request:any;
    reporting_time?:any;
    seva_time?:any;
    date?:any;
    tokendetails?:any;
    receipt_no?:any;
}


// WEBPACK FOOTER //
// ./src/models/shashwathaSeva.ts